
<template>
  <div>
    <div class="tree-menu" @click="closeMenu">
       <a href="#" class="folder-container" :style="indent" @click.prevent="toggleChildren">
        <div class="folder-icon" @click="openMenu">
          <a href="" ><app-icon name="more-vertical"/></a>

          <i v-if="label == 'Click to Expand'"  class="fa fa-desktop file-icon-color"></i>
          <i v-else :class="is_type == 'folder' ? 'fa fa-folder folder-icon-color' : 'fa fa-file file-icon-color'"></i>
        </div>

        <div class="folder-detail"@contextmenu.prevent="openMenu" @click.prevent="redirectBody()" >
          <div class="folder-name position-relative">{{ label }}</div>
          <small v-if="category_name" style="margin-top:1.5vh">({{ category_name }}) Last Update: {{ updated_at }}</small>
        </div>
        <nav id="main-menu" class="main-menu">  
          <ul class="nav-bar" :style="add" tabindex="-1" ref="right"  v-on:click="closeMenu">
            <li v-if="owner_id == this.userRole.id || (this.userRole.is_company_admin == 1 && this.userRole.company_id == 1)" @click="edit(form_id)"><app-icon name="edit" style="width:18px; height: 18px"/> Edit</li>
            <li v-if="owner_id == this.userRole.id && is_type == 'file'  || (this.userRole.is_company_admin == 1 && this.userRole.company_id == 1)" @click="assign(form_id)"><app-icon name="check-square" style="width:18px; height: 18px"/> Assign form</li>
            <li v-if="owner_id == this.userRole.id && is_type == 'file'  || (this.userRole.is_company_admin == 1 && this.userRole.company_id == 1)" @click="saveResponse(form_id)"><app-icon name="save" style="width:18px; height: 18px"/> Save response</li>
            <li v-if="owner_id == this.userRole.id && is_type == 'folder'  || (this.userRole.is_company_admin == 1 && this.userRole.company_id == 1)" @click="newFile(form_id)"><app-icon name="file-plus" style="width:18px; height: 18px"/> New File</li>
            <li v-if="owner_id == this.userRole.id && is_type == 'folder'  || (this.userRole.is_company_admin == 1 && this.userRole.company_id == 1)" @click="newFolder(form_id)"> <app-icon name="file-plus" style="width:18px; height: 18px"/> New Folder</li>
            <li v-if="owner_id == this.userRole.id  || (this.userRole.is_company_admin == 1 && this.userRole.company_id == 1)" @click="defaultFormThemeSet(form_id)"><app-icon name="upload" style="width:18px; height: 18px"/> Set Theme</li>
            <li v-if="owner_id == this.userRole.id  || (this.userRole.is_company_admin == 1 && this.userRole.company_id == 1)" @click="remove(form_id)"><app-icon name="trash" style="width:18px; height: 18px"/> Delete</li>
            <li v-if="is_type == 'file'" @click="view(form_id,null)"><app-icon name="list" style="width:18px; height: 18px"/> Form Builder</li>
            <li v-if="is_type == 'file'" @click="addToEmploymentContracts(form_id,null)"><app-icon name="plus" style="width:18px; height: 18px"/>Add/Remove - Employment Contracts</li>
            <li v-if="is_type == 'file' && owner_id != this.userRole.id  || (this.userRole.is_company_admin == 1 && this.userRole.company_id == 1)" @click="useTemplate(form_id)"><app-icon name="upload" style="width:18px; height: 18px"/> Use Template</li>

            <li v-if="is_type == 'folder' && !checkCompany" @click="importFolderOptions(form_id)"><app-icon name="upload" style="width:18px; height: 18px"/> Import Folder</li>
          </ul>
        </nav>
      </a>
    </div>

    <tree-menu
        v-if="showChildren"
        v-for="node in nodes"
        :key="node.id"
        :nodes="node.nodes"
        :label="node.label"
        :is_type="node.is_file_folder"
        :depth="depth + 1"
        :owner_id="node.owner_id"
        :category_name="node.category_name"
        :form_id="node.id"
        :type="type"
        :myForm="myForm"
        :refresh="refresh"
        :sendToChield="sendToChield"
        :updated_at="node.updated_at"
        :expanded="true"
    />
    <documentlibrary-addmodal
      v-if="isAddEditModalActive"
      :type="type"
      :parentId="parent_id"
      :refresh='refresh'
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelledConformation"
    />
    <app-formBuilder-modal
      v-if="formBuilderModalActive"
      :id="id"
      :type="type"
      :myform="myForm"
      :viewType="viewType"
      @close-modal="closeFormBuilderModal"
    />
    <documentlibrary-AddUpdateFolderModal
      v-if="isAddEditFolderModalActive"
      :type="type"
      :refresh='refresh'
      :selectedId ="parent_id"
      @close-modal="closeAddEditFolderModal"
    />

    <import-folder-forms-styling-modal
      v-if="formsStylingModalActive"
      :formBodyId="formBodyId"
      :formId="formId"
      :close_modal="closeFormsStylingModal"
      @close-modal="closeFormsStylingModal"
    />

    <!-- This comal is use for form import if form is alrwady impoted and want to again import conformation -->
    <app-delete-modal
      v-if="confirmationModalActive"
      :preloader="deleteLoader"
      :message="$t('again_import_form_message')"
      modal-id="form-confirmation"
      @confirmed="importFolder"
      @cancelled="cancelledConfirmation"
    /> 

</div>
</template>
<script>
import * as actions from "../../../../Config/ApiUrl";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";


  export default { 
    extends: CoreLibrary,
    props: ['importFlag','label', 'category_name', 'nodes', 'is_type', 'depth', 'owner_id', 'form_id', 'myForm', 'type', 'refresh', 'sendToChield', 'updated_at', 'expanded'],
    data() {
      return {
        formBodyId: 0,
        formId: 0,
        viewType: '',
        showChildren: false, 
        icon:'fa fa-caret-down fa-1x' ,  
        viewMenu: false,
        top: '0px',
        left: '0px',
        isAddEditModalActive: false,
        deleteConfirmationModalActive: false,
        deleteLoader: false,
        formBuilderModalActive: false,
        id: 0,
        selectedUrl: '',
        parent_id: 0,
        isAddEditFolderModalActive: false,
        formsStylingModalActive: false,
        selectedFormId: 0,
        confirmationModalActive: false,
      }
    },
    name: 'tree-menu',
    created() {
      this.showChildren = this.depth === 0;
    },
    computed: {
      indent() {
        const indentSize = 20; // increase from 50 to 80 for more spacing
        return { transform: `translate(${this.depth * indentSize}px)` }
      },
      add(){
        return { left: `${this.depth * 100}px` }
      },
      userRole() {
        return this.$store.state.user.loggedInUser;
      },
      checkCompany(){
        let sameCompany = true;
        let nodeCompany = this.nodes[0] && this.nodes[0].company_id;
        sameCompany = sameCompany && nodeCompany === this.$store.state.user.loggedInUser.company_id
        return sameCompany;
      }
    },
    methods: {
      useTemplate(formId) {
        let activeValue = 2;
        this.sendToChield(formId, activeValue);
      },
      assign(formId){
        let url = '/admin/tasks/create?formId=' + encodeURIComponent(formId);
        window.open(url, '_blank');
      },
      saveResponse(formId){
        let url = '/form-response?formId=' + encodeURIComponent(formId);
        window.open(url, '_blank');
      },

      redirectBody() {
        // && this.owner_id == this.userRole.id
        if(this.is_type == 'file' && this.viewMenu == false) {
          // alert(this.is_type+'/'+this.form_id);
          this.view(this.form_id,'formBuildScreen');
        }
      },
      edit(form_id) {
        this.selectedUrl = actions.FORM_GET_EDIT+'/'+form_id;
        this.isAddEditModalActive = true;
      },
      closeAddEditModal() {
        $("#demo-add-edit-Modal").modal("hide");
        this.isAddEditModalActive = false;
        this.refresh();
      },
      view(id,value) {
        this.id = id;
        this.viewType = value;

        this.openFormBuilderModal();
      },
      addToEmploymentContracts(id) {
        this.axiosPost({url: actions.ADD_TO_SCREENING_DOCUMENTS+'/'+id})
            .then((response) => {
              this.$toastr.s(response.data.message);
        })
            .catch(({ error }) => {
              // Trigger after error
            })
            .finally(() => {

            });
      },
      defaultFormThemeSet(id) {
        let url = `${actions.DEFAULT_FORM_THEME_SET}/${id}`;
        this.axiosGet(url)
          .then((response) => {
            if (response.data.type == 'success') {
                this.$toastr.s(response.data.message);

            }
            else if (response.data.type == 'info') {
                this.$toastr.i(response.data.message);
            }
            else {
                this.$toastr.W(response.data.message);
            }
          })
          .catch(({ error }) => {
            // Trigger after error
          });
      },
      openFormBuilderModal() {
        this.formBuilderModalActive = true;
      },
      closeFormBuilderModal() {
        $('.modal-backdrop').remove();
        this.formBuilderModalActive = false;
        this.refresh();
      },
      closeFormsStylingModal() {
        this.formId = 0;
        this.formBodyId = 0;
        $("#import-forms-styling-modal").modal("hide");
        this.isAddEditModalActive = false;
        this.refresh();
      },
      toggleChildren() {
        this.showChildren = !this.showChildren;
        this.icon = this.showChildren ? 'fa fa-caret-up fa-1x' : 'fa fa-caret-down fa-1x'
      },
      handler(){
        alert("hello");
      },
       setMenu: function(top, left) {
          
            let largestHeight = window.innerHeight - this.$$.right.offsetHeight - 75;
            let largestWidth = window.innerWidth - this.$$.right.offsetWidth - 25;

            if (top > largestHeight) top = largestHeight;

            if (left > largestWidth) left = largestWidth;

            this.top = top + 'px';
            this.left = 200 + 'px';
        },

        closeMenu: function() {
            this.viewMenu = false;
        },

      openMenu: function(e) {
        const menuDivs = document.querySelectorAll('.main-menu');

        // Loop through each of the div elements
        menuDivs.forEach((menuDiv) => {
          const clickedElement = e.target;
          let mainMenuElement = '';
          if(clickedElement.nextElementSibling && clickedElement.nextElementSibling.nextElementSibling){

          mainMenuElement = clickedElement.nextElementSibling.nextElementSibling;
          }else{
            mainMenuElement = clickedElement.parentElement.parentElement.parentElement.parentElement.closest('div')
                .querySelector('#main-menu');
               e.target.parentElement.parentElement.parentElement.parentElement.closest('div')
                .querySelector('.folder-name').classList.add('selected');
          }
          // Toggle the active class on the clicked div element
          if (menuDiv === clickedElement || menuDiv.contains(mainMenuElement)) {
            mainMenuElement.classList.toggle('active');
            clickedElement.classList.toggle('selected');
           } else {
            // Remove the active class from all the other div elements
            menuDiv.classList.remove('active');
            menuDiv.closest('div').querySelector('.folder-name').classList.remove('selected');
          }

        });
      },
      remove(deleting_id) {
        this.deleting_id = deleting_id;
        this.deleteConfirmationModalActive = true;
      },
      /**
     * confirmed $emit Form confirmation modal
     */
      confirmed() {
        let url = `${actions.FORMS_DELETE}/${this.deleting_id}`;
        this.deleteLoader = true;
        this.axiosDelete(url)
          .then((response) => {
            this.deleteLoader = false;
            $("#demo-delete").modal("hide");
            this.cancelled();
            this.$toastr.s(response.data.message);
          })
          .catch(({ error }) => {
            // Trigger after error
          })
          .finally(() => {
            this.refresh();
          });
      },
      // importFolder() {
      //   let url = `${actions.DOCUMENT_IMPORT_TO_MYLIBRARY}/${this.formId}`;
      //   this.axiosGet(url)
      //     .then((response) => {
      //       if (response.data.formBodyIds.length > 0) {
      //           this.formBodyIds = response.data.formBodyIds;
      //           this.form_body_id = response.data.formBodyIds[0];
      //       }
      //       this.$toastr.s(response.data.message);
      //       this.closeFormsStylingModal();
      //     })
      //     .catch(({ error }) => {
      //       // Trigger after error
      //     });
      // },
      importFolderOptions(form_id) {
        this.selectedFormId = form_id;
        //Check before import
        let url = `${actions.CHECK_BEFORE_IMPORT}${form_id}`;
        this.axiosGet(url)
          .then((response) => {
            if (response.data.alreadyImported) {
              this.confirmationModalActive = true;
            }
            else {
              this.importFolder();
            }
          })
          .catch(({ error }) => {
            // Trigger after error
          });
      },
      importFolder() {
        this.cancelledConfirmation();
        const form_id = this.selectedFormId;
        let url = `${actions.GET_IMPORT_FORM_BODY}/${form_id}`;
        this.axiosGet(url)
          .then((response) => {
            if (response.data.formBodyId) {
                this.formId = form_id;
                this.formBodyId = response.data.formBodyId;
            }
            else {
              this.$toastr.s(response.data.message);
            }
          })
          .catch(({ error }) => {
            // Trigger after error
          });
      },
      cancelledConfirmation() {
        $("#form-confirmation").modal("hide");
        this.confirmationModalActive = false;
      },

      checkOpenModal() {
      if (this.formId !== 0 && this.formBodyId !== 0) {
        this.formsStylingModalActive = true;
      } else {
        this.formsStylingModalActive = false;
      }
    },

      /**
       * cancelled $emit Form confirmation modal
       */
      cancelled() {
        this.deleteConfirmationModalActive = false;
        this.reSetData();
      },
      reSetData() {
        this.selectedUrl = "";
        this.refresh();
      },
      newFile(parent_id) {
        this.selectedUrl = "";
        this.parent_id = parent_id;
        this.isAddEditModalActive = true;
      },
      newFolder(parent_id) {
        this.selectedUrl = "";
        this.parent_id = parent_id;
        this.isAddEditFolderModalActive = true;
      },
      closeAddEditFolderModal() {
        $("#demo-add-edit-folder-Modal").modal("hide");
          this.isAddEditFolderModalActive = true;
          this.refresh();
      },
    },
    watch: {
      formId(newVal) {
      this.checkOpenModal();
    },
    formBodyId() {
      this.checkOpenModal();
    }
  }
  }
</script>

<style>
.main-menu{
  top: 100%;
  z-index: 999;
  /* position: absolute; */
  content: '';
  left: 100px;
  background: #ededed;
  padding: 5px;
  box-shadow: 0 0 10px #ecec;
  display: none;
}
.main-menu.active{
  display: block;
}
.folder-name.selected{
  text-decoration: underline;
  font-weight: bold;
  color: #5666b4;
  font-size: 16px;
}
.tree-menu-parent a {
  color: black;
}
#main-menu .nav-bar {
  list-style: none;
  border: 1px solid #BDBDBD;
  /* box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12); */
  margin-left: 10px;
  padding: 0;
  width: 150px;
  /* margin-top: 40px; */
  
}
#main-menu .nav-bar li {
  display: block;
  border-bottom: 1px solid #E0E0E0;
  margin: 0;
  color: #292f4c;
  font-size: 12px;
  /* font-weight:bold; */
  padding: 5px 5px;
}
#main-menu .nav-bar li:hover {
    background: #292f4c;
    color: #fff;
}
/*Style End*/

/* file folder ui */
.card-folders .card-body > .breadcrumb {
  margin-left: -1.25em;
  margin-right: -1.25em;
  margin-top: -1.25em;
  border-radius: 0;
}

.folder-container {
  position: relative;
  left: 50px!important;
  text-align: center;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-bottom: 1.5rem;
  width: 100px;
  padding: 0;
  align-self: start;
  background: none;
  border: none;
  outline-color: transparent !important;
  cursor: pointer;
}
.folder-icon {
  font-size: 3em;
  line-height: 1.25em;
}
.folder-icon-color {
  color: #ffc107;
  text-shadow: 1px 1px 0px #e0a800;
  font-size: 25px;
}
.folder-name {
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  font-size: 14px;
}

.flex-column .folder-container {
  display: flex;
  width: auto;
  min-width: 100px;
  text-align: left;
  margin: 0 0 1rem;
}
.flex-column .folder-icon, .flex-column .folder-name {
  display: inline-flex;
}
.flex-column .folder-icon {
  font-size: 1.4em;
  margin-right: 1rem;
}
.file-icon-color {
  color: #292f4c;
  font-size: 25px;
}
/*.folder-detail:hover {*/
/*  font-weight: bold;*/
/*  color: #5666b4;*/
/*  font-size: 22px;*/
/*} */
</style>